module.exports = __webpack_public_path__ + "static/media/joares_lidovino_dos_reis.7a6a01b2.jpg";